import Constants from './Constants';
import type { App } from 'vue';

export function initGlobalProperties(app : App) {
  app.config.globalProperties.$constants = Constants;
  app.config.globalProperties.__VERSION__ = __VERSION__;
  app.config.globalProperties.__BUILD_DATE__ = __BUILD_DATE__;
  app.config.globalProperties.__DEV__ = __DEV__;
  app.config.globalProperties.__API_BASE__ = __API_BASE__;
  app.config.globalProperties.__USE_PLAYWRIGHT__ = __USE_PLAYWRIGHT__;
  app.config.globalProperties.__GENERATE_PLAYWRIGHT_TESTS__ = __GENERATE_PLAYWRIGHT_TESTS__;
  app.config.compilerOptions.isCustomElement = (tag) => { return tag.startsWith("v-")};
}